import type { PanelSpecGroup } from './panel-types'

interface SpecRowProps {
  spec: PanelSpecGroup
  expandable: boolean
}

const MappingLabel = ({ name, tooltipId }: { name: string; tooltipId: string }) => (
  <span
    className="w-1/2 shrink-0 cursor-help text-left text-xs text-slate-400 underline decoration-slate-300 decoration-dotted underline-offset-2 transition-colors hover:text-slate-600 hover:decoration-slate-500"
    data-spec-tooltip-id={tooltipId}
  >
    {name}
  </span>
)

export const SpecRow = ({ spec, expandable }: SpecRowProps) => {
  const [onlyMapping] = spec.mappings

  return (
    <div
      className="border-b border-slate-100 py-2.5 data-[expanded]:block"
      {...(expandable ? { 'data-expandable': '' } : {})}
    >
      {spec.mappings.length === 1 && onlyMapping ? (
        <div className="flex items-center justify-between gap-3">
          <MappingLabel name={spec.name} tooltipId={onlyMapping.tooltipId} />
          <span className="text-navy w-1/2 text-sm leading-tight font-semibold">{onlyMapping.value}</span>
        </div>
      ) : (
        <div role="group" aria-label={spec.name}>
          <p className="text-navy/75 text-xs leading-tight font-semibold">{spec.name}</p>
          <div className="mt-1.5 border-l-2 border-slate-100 pl-2.5">
            {spec.mappings.map((mapping) => (
              <div key={mapping.id} className="flex items-center justify-between gap-3 py-1.5">
                <MappingLabel name={mapping.name} tooltipId={mapping.tooltipId} />
                <span className="text-navy w-1/2 text-sm leading-tight font-semibold">{mapping.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
